import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

export interface ProviderLabelGamesInput {
  providerId: number;
  labelId: number;
  brandname?: string;
  categoryType?: string;
}

export function buildProviderLabelGamesInput(
  providerId: number,
  labelId: number,
  brandname?: string,
  category?: string,
): ProviderLabelGamesInput {
  const input: ProviderLabelGamesInput = { providerId, labelId };

  if (brandname && brandname !== 'ALL') {
    input.brandname = brandname;
  }

  if (category && category !== 'ALL') {
    input.categoryType = category;
  }

  return input;
}

const ARE_ALL_GAMES_ENABLED_QUERY = gql`
  query AreAllGamesEnabledForLabel($input: ProviderLabelGamesInput!) {
    areAllGamesEnabledForLabel(input: $input)
  }
`;

const ACTIVATE_ALL_GAMES_MUTATION = gql`
  mutation ActivateAllGamesForLabel($input: ProviderLabelGamesInput!) {
    activateAllGamesForLabel(input: $input) {
      activatedCount
      totalGames
    }
  }
`;

const DEACTIVATE_ALL_GAMES_MUTATION = gql`
  mutation DeactivateAllGamesForLabel($input: ProviderLabelGamesInput!) {
    deactivateAllGamesForLabel(input: $input) {
      deactivatedCount
    }
  }
`;

export async function areAllGamesEnabledForLabel(
  input: ProviderLabelGamesInput,
): Promise<boolean> {
  const { data } = await apolloClient.query<{
    areAllGamesEnabledForLabel: boolean;
  }>({
    query: ARE_ALL_GAMES_ENABLED_QUERY,
    variables: { input },
    fetchPolicy: 'network-only',
  });

  return data?.areAllGamesEnabledForLabel ?? false;
}

export async function activateAllGamesForLabel(
  input: ProviderLabelGamesInput,
): Promise<void> {
  await apolloClient.mutate({
    mutation: ACTIVATE_ALL_GAMES_MUTATION,
    variables: { input },
  });
}

export async function deactivateAllGamesForLabel(
  input: ProviderLabelGamesInput,
): Promise<void> {
  await apolloClient.mutate({
    mutation: DEACTIVATE_ALL_GAMES_MUTATION,
    variables: { input },
  });
}
